<template>
    <div class="tw-bg-white tw-rounded-sm tw-border tw-border-gray-200 tw-p-6 tw-space-y-8">

    </div>
</template>

<script setup>

</script>